import { render, staticRenderFns } from "./RequestsNew.vue?vue&type=template&id=56c60655&scoped=true"
import script from "./RequestsNew.vue?vue&type=script&lang=js"
export * from "./RequestsNew.vue?vue&type=script&lang=js"
import style1 from "./RequestsNew.vue?vue&type=style&index=1&id=56c60655&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c60655",
  null
  
)

export default component.exports